import { render, staticRenderFns } from "./pay-code.vue?vue&type=template&id=3ac063f2&scoped=true"
import script from "./pay-code.vue?vue&type=script&lang=js"
export * from "./pay-code.vue?vue&type=script&lang=js"
import style0 from "./pay-code.vue?vue&type=style&index=0&id=3ac063f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac063f2",
  null
  
)

export default component.exports